import { env } from '../utils/env'

export const OS_API_KEY = env('REACT_APP_OMNISEND_API_KEY')
export const RECAPTCHA_SITE_KEY = env('REACT_APP_RECAPTCHA_SITE_KE')
